module.exports = __webpack_public_path__ + "static/media/location-marker-blue.ee204060.svg";